import { jsx as _jsx } from "react/jsx-runtime";
import { formatDistance } from 'date-fns';
import { memo, useEffect, useState } from 'react';
const TimeAgoMessage = ({ timestampUnix, updateIntervalInSeconds = 30, locale, }) => {
    // side effect is necesary
    // eslint-disable-next-line react-hooks/purity
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), updateIntervalInSeconds * 1000);
        return () => clearInterval(interval);
    }, [updateIntervalInSeconds]);
    return (_jsx("small", { children: formatDistance(timestampUnix, now, {
            addSuffix: true,
            locale,
        }) }));
};
export default memo(TimeAgoMessage);
//# sourceMappingURL=TimeAgoMessage.js.map